/**
 * GlobalComponents.jsx
 * 
 * This file contains reusable React components that are intended to be used globally throughout the application.
 * Each component is designed to be self-contained and easily imported into any part of the application.
 * 
 * Purpose:
 * - To provide a centralized location for small, reusable components to promote code reuse and consistency.
 * - To simplify the inclusion of common elements such as buttons, links, icons, etc., by exporting them from a single file.
 * 
 * Usage:
 * - Import the desired component from this file into your React component or page.
 * - Example: import { BackArrowButton } ;
 * 
 * Global Accessibility:
 * - Optionally, components can be attached to the `window` object to make them globally accessible.
 * - Example: window.BackArrowButton = BackArrowButton;
 */

import useGoBack from '../../hooks/useGoBack';

// Back Button Component
const BackArrowButton = () => {
    const goBack = useGoBack();

    return (
        <Link
            to="#"
            onClick={goBack}
            className="back-arrow"
           >
            <FaArrowLeft  />
            Back
        </Link>
    );
};
// cancel button component
const CancelButton = () => {
    const goBack = useGoBack();

    return (
        <Button type="button" variant="secondary" onClick={goBack} className="ms-4">
            Cancel
        </Button>
    );
};

//  document click handler for viewing files 
const DocumentLinkClickHandler = ({ url, title }) => {
    const handleDocumentLinkClick = (url) => (event) => {
        event.preventDefault();
        window.open(url, '_blank');
    };
    return (<Link to="#" onClick={handleDocumentLinkClick(url)}>{title}</Link>);
};

export { BackArrowButton, CancelButton, DocumentLinkClickHandler };